import { useState } from "react";
export const useTvl = () => {
    const [ tvl, setTvl ] = useState(0);
    
    return [tvl, setTvl]
}